export default __webpack_public_path__ + "2e239fb36fe1a8f76f38c551c32771db.svg";